import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APIcon } from '@components/atoms/APIcon';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

export const PoweredByAstroPay = () => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center mb-4">
      <APIcon img="lockLine" size={15} />
      <Typography
        textKey="Checkout.secureCheckoutPoweredBy"
        className="text-[#64748B] text-[14px]"
      />
      <APImage
        img={logo}
        width={55}
        height={13}
        alt={t('AstroPayDownload.title')}
        className="ml-1"
      />
    </div>
  );
};
